<template>

    <div class="c-rkw-modal"
         v-bind:class="{'c-rkw-modal--open-right': (item !== null && position === 'right'), 'c-rkw-modal--open-left': (item !== null && position === 'left'), 'c-rkw-modal--onFlip': (item !== null && flip === true), 'c-rkw-modal--open-big': (item !== null && zoom === true)}">
        <div class="c-rkw-modal__flip c-rkw-modal__flip--front">
            <div class="c-rkw-modal__wrapper" v-bind:class="color">
                <div class="c-rkw-modal__content" v-if="item !== null">
                    <div class="c-rkw-content__small-wrap" v-touch:swipe.left="getNextInstance"
                         v-touch:swipe.right="getPrevInstance">
                        <div class="c-rkw-content__breadcrumb">
                            <span class="c-rkw-content__breadcrumb-item">{{model.title}}</span>
                            <span class="c-rkw-content__breadcrumb-item">{{mechanism.title}}</span>
                            <strong style="display: block;">{{task.title}}</strong>
                        </div>
                        <div class="c-rkw-content__slider c-rkw-slider">
                            <div class="c-rkw-slider__item">
                                <figure class="c-rkw-slider__image c-rkw-slider__image--active"
                                        :style="'background-image: url(' + settings.pageUrl + item.sliderImages[0][0] + ')'">

                                </figure>
                            </div>
                        </div>

                        <h3 class="c-rkw-content__header">
                            {{item.content.subheader}}
                        </h3>
                        <p class="c-rkw-content__body">{{item.content.header}}<br><br>
                            {{item.content.teaser}}
                        </p>
                        <div class="c-rkw-content__buttons">
                            <span v-if="!isBookmarked(uid)" class="c-rkw-content__button c-rkw-content__button--like"
                                  v-on:click="addBookmark(uid, 'bookmarks', $event)"></span>
                            <span v-if="isBookmarked(uid)" class="c-rkw-content__button c-rkw-content__button--unlike"
                                  v-on:click="removeBookmark(uid)"></span>

                            <span class="c-rkw-content__button c-rkw-content__button--showmore"
                                  v-on:click="toggleZoom"></span>

                            <span class="c-rkw-content__button c-rkw-content__button--flip"
                                  v-on:click="toggleFlip"></span>
                        </div>
                    </div>
                    <content-detail></content-detail>
                </div>
            </div>
            <a href="#" class="c-rkw-modal__nav-zoom"></a>
            <a href="#" data-title="Fenster schließen" v-on="{ mouseenter: showTooltip, mouseleave: hideTooltip, mousemove: moveMouse }" class="c-rkw-modal__nav-close" @click.prevent="setInactive"></a>
            <a :href="'/beispiel/' + this.getInstanceURI(this.prev)" class="c-rkw-modal__nav-prev" @click.prevent="getPrevInstance"><span class="">{{prevTitle}}</span></a>
            <a :href="'/beispiel/' + this.getInstanceURI(this.next)" class="c-rkw-modal__nav-next" @click.prevent="getNextInstance"><span class="">{{nextTitle}}</span></a>
            <div class="c-rkw-modal__bullet-nav" v-if="item !== null">
                <span v-for="(instance, instanceKey) in task['instances']" v-bind:key="instanceKey" class="c-rkw-modal__bullet"
                      v-bind:class="{'c-rkw-modal__bullet--active': (uid === instance)}"
                      @click.prevent="setActive(instance)"></span>
            </div>
        </div>
        <div class="c-rkw-modal__flip c-rkw-modal__flip--back">
            <div class="c-rkw-modal__wrapper" v-bind:class="color">
                <div class="c-rkw-modal__content" v-if="item !== null">
                    <div class="c-rkw-content__small-wrap" v-touch:swipe.left="getNextTask"
                         v-touch:swipe.right="getPrevTask">
                        <div class="c-rkw-content__breadcrumb">
                            <span class="c-rkw-content__breadcrumb-item">{{model.title}}</span>
                            <span class="c-rkw-content__breadcrumb-item">{{mechanism.title}}</span>
                            <strong style="display: block;">{{task.title}}</strong>
                        </div>
                        <div class="c-rkw-content__slider c-rkw-slider">
                            <div class="c-rkw-slider__item">
                                <figure class="c-rkw-slider__image c-rkw-slider__image--active c-rkw-slider__image--mechanism-icon">

                                </figure>
                            </div>
                        </div>

                        <h3 class="c-rkw-content__header">
                            {{task.infoTitle}}
                        </h3>
                        <p class="c-rkw-content__body c-rkw-content__body--weight-invert" v-html="task.infoText">

                        </p>

                        <div class="c-rkw-content__buttons">
                            <span v-if="!isBookmarked(uid)" class="c-rkw-content__button c-rkw-content__button--like"
                                  v-on:click="addBookmark(uid, 'bookmarks', $event)"></span>
                            <span v-if="isBookmarked(uid)" class="c-rkw-content__button c-rkw-content__button--unlike"
                                  v-on:click="removeBookmark(uid)"></span>

                            <span class="c-rkw-content__button c-rkw-content__button--showmore"
                                  v-on:click="toggleZoomReverseSide"></span>

                            <span class="c-rkw-content__button c-rkw-content__button--flip-back c-rkw-content__button--invert"
                                  v-on:click="toggleFlip"></span>
                        </div>
                    </div>
                </div>
            </div>
            <a :href="'/beispiel/' + this.getInstanceURI(this.prevTask)" class="c-rkw-modal__nav-prev" @click.prevent="getPrevTask"></a>
            <a :href="'/beispiel/' + this.getInstanceURI(this.nextTask)" class="c-rkw-modal__nav-next" @click.prevent="getNextTask"></a>
            <div class="c-rkw-modal__bullet-nav" v-if="item !== null">
                <span v-for="(_task, _taskKey) in mechanism['tasks']" v-bind:key="_taskKey" class="c-rkw-modal__bullet"
                      v-bind:class="{'c-rkw-modal__bullet--active': (task.id === _task)}"
                      @click.prevent="setActive($store.state.data.tasks[_task]['instances'][0])"></span>
            </div>
        </div>
    </div>

</template>

<script>

  import mixins from "../mixins"

  export default {
    data() {
      return {}
    },
    watch: {
      '$route'() {
        if (this.$route.params.instance && this.$store.state.runtime.activeItems.instance !== parseInt(this.$route.params.instance)) {
          this.$store.commit('setActiveInstance', parseInt(this.$route.params.instance))
        }
      },
      uid() {
        if (this.model && this.mechanism && this.task && this.item) {
          let title = this.mechanism.title + ' > ' + this.task.title + ' > ' + this.item.content.header
          this.eTrackerLog(this.model.title, title, this.$route.path)
        }
      }
    },
    created() {
      if (this.$route.params.instance) {
        this.setActive(parseInt(this.$route.params.instance))
      }
    },
    mixins: [mixins],
    computed: {
      settings() {
        return this.$store.state.settings
      },
      uid() {
        return this.$store.state.runtime.activeItems['instance']
      },
      item() {
        return (this.$store.state.runtime.activeItems['instance'] === null)
          ? null
          : this.$store.state.data['instances'][this.$store.state.runtime.activeItems['instance']]
      },
      model() {
        return this.$store.state.data['models']['uid' + this.$store.state.runtime.activeItems['model']]
      },
      mechanism() {
        return this.$store.state.data['mechanisms'][this.$store.state.runtime.activeItems['mechanism']]
      },
      task() {
        return this.$store.state.data['tasks'][this.$store.state.runtime.activeItems['task']]
      },
      position() {
        if (this.$store.state.runtime.activeItems['model'] === null) return
        let model = this.$store.state.data['models']['uid' + this.$store.state.runtime.activeItems['model']]
        let attr = (model['position'].indexOf('-left') !== -1) ? 'right' : 'left'
        return (this.$store.state.runtime.activeItems['instance'] !== null) ? attr : ''
      },
      color() {
        return (this.item !== null) ? 'c-rkw-modal__wrapper' + this.model['color'] : ""
      },
      flip() {
        return this.$store.state.runtime.content.flip
      },
      zoom() {
        return this.$store.state.runtime.content.zoom
      },
      prev() {
        return this.findPrevItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])
      },
      prevTitle() {
        //return this.$store.state.data['instances'][this.findPrevItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])]
        let obj = this.$store.state.data['instances'][this.findPrevItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])]
        if(typeof obj !== 'undefined' && obj.hasOwnProperty('content')) {
          return obj.content.header
        }
      },
      next() {
        return this.findNextItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])
      },
      nextTitle() {
        let obj = this.$store.state.data['instances'][this.findNextItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])]
        if(typeof obj !== 'undefined' && obj.hasOwnProperty('content')) {
          return obj.content.header
        }
      },
      prevTask() {
        let prev = this.findPrevItem(this.$store.state.runtime.allItems['tasks'], this.$store.state.runtime.activeItems['task'])
        if (prev !== false) {
          if (this.$store.state.data['tasks'][prev])
            prev = this.$store.state.data['tasks'][prev]['instances'][0]
        }
        return prev
      },
      nextTask() {
        let next = this.findNextItem(this.$store.state.runtime.allItems['tasks'], this.$store.state.runtime.activeItems['task'])
        if (next !== false) {
          if (this.$store.state.data['tasks'][next])
            next = this.$store.state.data['tasks'][next]['instances'][0]
        }
        return next
      }
    },
    methods: {
      setActive(instanceId) {
        this.setActiveInstance(instanceId)
      },
      getActive() {
        return this.$store.state.runtime.activeItems['instance']
      },
      setInactive() {
        this.$store.commit('unsetActiveInstance')
        router.push({path: '/'})
      },
      toggleFlip() {
        this.$store.commit('toggleContentFlip')
        return this.flip
      },
      toggleZoom() {
        this.$store.commit('toggleContentZoom')
        return this.zoom
      },
      toggleZoomReverseSide() {
          this.toggleFlip();
          this.$store.commit('toggleContentZoom')
          return this.zoom
        },
      getNextInstance() {
        let next = this.findNextItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])
        if (next !== false) {
          this.setActive(next)
        }
      },
      getPrevInstance() {
        let prev = this.findPrevItem(this.$store.state.runtime.allItems['instances'], this.$store.state.runtime.activeItems['instance'])
        if (prev !== false) {
          this.setActive(prev)
        }
      },
      getNextTask() {
        let next = this.findNextItem(this.$store.state.runtime.allItems['tasks'], this.$store.state.runtime.activeItems['task'])
        if (next !== false) {
          next = this.$store.state.data['tasks'][next]['instances'][0]
          this.setActive(next)
        }
      },
      getPrevTask() {
        let prev = this.findPrevItem(this.$store.state.runtime.allItems['tasks'], this.$store.state.runtime.activeItems['task'])
        if (prev !== false) {
          prev = this.$store.state.data['tasks'][prev]['instances'][0]
          this.setActive(prev)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ContentModal.vue?30f47c5b